import { Typography } from '@mui/material';
import MomentFormatter from '@app/utils/moment';
import RenderViewContainer from '../../RenderViewContainer';

export default function DatePickerRenderView({ state, label }) {
  return (
    <RenderViewContainer
      label={label}
      children={
        <Typography fontSize="16px" fontWeight={500} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {MomentFormatter.isValid(state) ? MomentFormatter.from(state).fullDate() : '--'}
        </Typography>
      }
    />
  );
}
